import * as React from 'react'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

interface IProps {
  content?: React.ReactNode
  side?: 'top' | 'bottom' | 'left' | 'right'
  disabled?: boolean
  // Must be a single element that forwards its ref to a DOM node (DOM element or styled-component)
  children: React.ReactElement
}

/**
 * Wraps a single element with a shadcn tooltip without adding an extra DOM node.
 * The tooltip is disabled (but the tree stays stable) when there is no content.
 */
const SimpleTooltip = ({ content, side = 'top', disabled = false, children }: IProps) => {
  return (
    <Tooltip disabled={disabled || !content}>
      <TooltipTrigger render={children} />
      {content && <TooltipContent side={side}>{content}</TooltipContent>}
    </Tooltip>
  )
}

export default SimpleTooltip
